const SAVE_ACCOUNT_FILTER = 'SAVE_ACCOUNT_FILTER';
const RESET_ACCOUNT_FILTER = 'RESET_ACCOUNT_FILTER';

const initialState = () => ({
    accountFilter: {
        typeuser: 0,
        bedrijf: 0,
        zoekstring: '',
    },
});

const module = {
    state: initialState(),
    mutations: {
        [SAVE_ACCOUNT_FILTER] (state, payload) {
            state.accountFilter = payload;
        },
        [RESET_ACCOUNT_FILTER] (s) {
            const initial = initialState();
            Object.keys(initial).forEach((key) => { s[key] = initial[key]; });
        },
    },
    actions: {
        saveAccountFilter ({ commit }, payload) {
            commit(SAVE_ACCOUNT_FILTER, payload);
        },
        resetAccountFilter ({ commit }, payload) {
            commit(RESET_ACCOUNT_FILTER, payload);
        },
    },
    getters: {
        accountFilter: state => state.accountFilter,
    },
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/account.js